import type {ReactElement} from 'react';
import React from 'react';
import {useSelectedAudioItem} from '@Hooks/poster-editor/useSelectedAudioItem';
import {BaseVolumeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-volume-option/base-volume-option';

interface AudioItemVolumeOptionProps {
  className?: string;
}

export function AudioItemVolumeOption({className = ''}: AudioItemVolumeOptionProps): ReactElement<any> | null {
  const selectedAudioItem = useSelectedAudioItem();

  if (!selectedAudioItem) {
    return null;
  }

  const updateAudioItemVolume = (volume: number, undoable: boolean): void => {
    void selectedAudioItem.updateFromObject(
      {
        audioPlayer: {
          volume,
        },
      },
      {
        undoable,
      }
    );
  };

  const onMuteUnMute = (): void => {
    void selectedAudioItem.updateFromObject(
      {
        audioPlayer: {
          volume: selectedAudioItem.audioPlayer.volume === 0 ? 1 : 0,
        },
      },
      {
        undoable: true,
      }
    );
  };

  return <BaseVolumeOption onMuteUnmute={onMuteUnMute} className={className} volume={selectedAudioItem.audioPlayer.volume} onUpdateVolume={updateAudioItemVolume} />;
}
